import React from "react";

function SectionCard(props) {
  return (
    <section className="relative bg-[#FAF9F6] py-28 overflow-hidden">
      
      {/* декоративное пятно */}
      {/* <div className="absolute -top-32 -left-32 w-[420px] h-[420px] bg-lime-200/30 rounded-full blur-3xl" />
      <div className="absolute bottom-0 -right-32 w-[420px] h-[420px] bg-amber-200/30 rounded-full blur-3xl" /> */}

      <div className="relative max-w-7xl mx-auto px-8 ">
        
        {/* Заголовок */}
        <div className="max-w-2xl mb-20">
          <p className="text-sm uppercase tracking-widest text-gray-400 mb-3">
            Ajar Mebel
          </p>
          <h2 className="text-4xl lg:text-5xl font-extrabold text-black leading-tight">
            Биздин бренддин <br /> айырмасы эмнеде?
          </h2>
        </div>

        {/* Контент */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          
          {/* Блок 1 */}
          <div className="relative pl-10">
            <span className="absolute left-0 top-0 text-6xl font-extrabold text-lime-500/30">
              01
            </span>

            <div className="text-4xl text-lime-500 mb-4">
              <ion-icon name="bag-check-outline"></ion-icon>
            </div>

            <h3 className="text-2xl font-semibold text-black mb-4">
              Столдун материалы
            </h3>

            <p className="text-lg text-gray-600 leading-relaxed">
              Туркиянын МДФ — так иштелген, узак мөөнөткө эсептелген
              жана күнүмдүк колдонууга идеалдуу.
            </p>

            <div className="mt-6 h-px w-16 bg-lime-500" />
          </div>

          {/* Блок 2 */}
          <div className="relative pl-10 lg:mt-16">
            <span className="absolute left-0 top-0 text-6xl font-extrabold text-lime-500/30">
              02
            </span>

            <div className="text-4xl text-lime-500 mb-4">
              <ion-icon name="construct-outline"></ion-icon>
            </div>

            <h3 className="text-2xl font-semibold text-black mb-4">
              Стулдун материалы
            </h3>

            <p className="text-lg text-gray-600 leading-relaxed mb-3">
              100% жангак — табигый, бекем жана экологиялык таза.
            </p>

            <p className="text-lg text-gray-600 leading-relaxed">
              Итальян боёктору — убакыт өтсө да түсүн жана
              эстетикасын сактайт.
            </p>

            <div className="mt-6 h-px w-16 bg-lime-500" />
          </div>

          {/* Блок 3 */}
          <div className="relative pl-10">
            <span className="absolute left-0 top-0 text-6xl font-extrabold text-lime-500/30">
              03
            </span>

            <div className="text-4xl text-lime-500 mb-4">
              <ion-icon name="cash-outline"></ion-icon>
            </div>

            <h3 className="text-2xl font-semibold text-black mb-4">
              Адилет баалар
            </h3>

            <p className="text-lg text-gray-600 leading-relaxed">
              Баалар өлчөмүнө жараша аныкталат.  
              <br />
              <span className="text-black font-medium">
                4 метрлик стол — 45 000 сом
              </span>
              <br />
              Стулдар - 5300 сомдон 7400 сомго чейин.
            </p>

            <div className="mt-6 h-px w-16 bg-lime-500" />
          </div>

        </div>
      </div>
     <div className="w-full overflow-hidden bg-black py-6 -mb-20 mt-16">
  <div className="marquee">
    <div className="marquee__inner">
      <span>AJAR MEBEL • ПРЕМИУМ САПАТ • ЖЕКЕ ДИЗАЙН •</span>
      <span>AJAR MEBEL • ПРЕМИУМ САПАТ • ЖЕКЕ ДИЗАЙН •</span>
    </div>
  </div>
</div>


    </section>
  );
}

export default SectionCard;
